/**
 * Search Highlight Overlay Component
 *
 * Renders yellow highlight overlays for search results on PDF pages
 */

import React from 'react';
import styles from './SearchHighlight.module.scss';

export interface SearchMatch {
  pageNumber: number;
  rects: Array<{ x: number; y: number; width: number; height: number }>;
}

export interface SearchHighlightProps {
  pageNumber: number;
  pageWidth: number;
  pageHeight: number;
  matches: SearchMatch[];
  currentMatchIndex: number;
  scale: number;
}

export const SearchHighlight: React.FC<SearchHighlightProps> = ({
  pageNumber,
  pageWidth,
  pageHeight,
  matches,
  currentMatchIndex,
  scale,
}) => {
  // Get matches for this page
  const pageMatches = matches.filter(m => m.pageNumber === pageNumber);
  if (pageMatches.length === 0) return null;

  return (
    <div className={styles.highlightLayer}>
      {pageMatches.map((match, matchIndex) =>
        match.rects.map((rect, rectIndex) => {
          const globalMatchIndex = matches.findIndex(m => m === match);
          const isCurrentMatch = globalMatchIndex === currentMatchIndex;

          // Coordinates are already at the correct scale (from viewport with renderScale)
          // No additional scaling needed - just use them directly
          return (
            <div
              key={`${matchIndex}-${rectIndex}`}
              className={`${styles.highlight} ${isCurrentMatch ? styles.current : ''}`}
              style={{
                left: `${rect.x}px`,
                top: `${rect.y}px`,
                width: `${rect.width}px`,
                height: `${rect.height}px`,
              }}
            />
          );
        })
      )}
    </div>
  );
};
